<template>
  <div class="image-loader">
    <div v-if="isBlacklistedFiles" class="image-loader--text">
      Sorry, {{ filename }} can’t open because the .{{ ext }} not permitted and
      temporary blocked. To view this file, the file type must be whitelisted.
      Please contact your Administrator to more information!
    </div>
    <div v-else>
      <div class="loading-image-container" v-show="isLoading">
        <i>
          <icon name="ic-load"></icon>
        </i>
        <span class="label">Loading Image...</span>
      </div>
      <div v-show="isImage && !isLoading && error == ''" class="qcw-image-container" @click="clickImageHandler">
        <img ref="imageContainer" :src="imageSrc" :alt="uri" @error="imageFallback" @load="imageLoaded" />
      </div>
      <div v-show="error">
        <p>
          <i style="font-size: 2em; display: inline-block">
            <icon name="close"></icon>
          </i>
          {{ error }}
        </p>
        <button @click="loadImage" class="reload-image-btn">
          Reload Image
        </button>
      </div>
      <div v-show="!isImage && !isLoading" class="qcw-file-container">
        <a v-if="!isCommentReply" href="javascript:void(0)" @click.prevent="isValidUri">
          <i>
            <icon :name="fileClassName" style="width: 24px;height: 24px;"></icon>
          </i>
          <div class="file-meta">
            <div class="file-name file-name-color" :style="fileMetaClassName">
              {{ filename }}
            </div>
            <!-- <div class="file-ext">{{ ext }}</div> -->
          </div>
        </a>
        <div v-if="isCommentReply" class="file-container-reply">
          <i>
            <icon :name="fileClassName" style="width: 24px;height: 24px;"></icon>
          </i>
          <div class="file-meta">
            <div class="file-name file-name-color" :style="fileMetaClassName">
              {{ filename }}
            </div>
            <!-- <div class="file-ext">{{ ext }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";

export default {
  name: "ImageLoader",
  components: { Icon },
  props: [
    "comment",
    "message",
    "whitelistedFiles",
    "callback",
    "onClickImage",
    "thumbnailMode",
    "isCommentReply",
    "isMe"
  ],
  data() {
    return {
      isLoading: true,
      isImage: false,
      imageSrc: "",
      uri: this.comment.getAttachmentURI(this.message),
      filename: "",
      ext: "",
      error: ""
    };
  },
  computed: {
    isReply() {
      return this.comment.type === "reply";
    },
    fileClassName() {
      let ext = this.ext.toLowerCase();
      const images = ["jpg", "jpeg", "gif", "webp", "png"];
      const extras = this.comment.extras;
      if (extras.source === "ig") {
        if (this.isCommentReply && this.isFileAttachment) {
          return "ic-file-attachment";
        }
        return "ic-ig-attachment";
      }
      if (images.indexOf(ext) > -1) return "ic-image";
      return "ic-file-attachment";
    },
    isBlacklistedFiles() {
      if (this.whitelistedFiles) {
        if (this.whitelistedFiles.length > 0)
          return !this.whitelistedFiles.includes(this.ext);
      }
      return false;
    },
    isFileAttachment() {
      if (this.comment.payload) {
        return this.comment.payload.replied_comment_type === "file_attachment";
      }
      return false;
    },
    fileMetaClassName() {
      if (!this.isCommentReply) {
        return this.isMe ? "color: #ffffff" : "color: #007BFF";
      } else {
        return "color: #565656";
      }
    }
  },
  created() {
    this.loadImage();
  },
  destroyed() {
    URL.revokeObjectURL(this.imageSrc);
  },
  methods: {
    isValidUri() {
      if (!this.uri || this.isCommentReply || this.isBlacklistedFiles)
        return false;
      if (this.uri.hostname === window.location.hostname) return false;
      const splittedUri = this.uri.split("/");
      const hasExtension = splittedUri[splittedUri.length - 1].includes(".");
      const actions = [];
      const extras = this.comment.extras;
      const isSourceInstagram = extras.source === "ig";
      if (
        isSourceInstagram &&
        extras.type === "audio" &&
        !this.isCommentReply
      ) {
        this.uri = this.comment.payload.text
          .replace("[file]", "")
          .replace("[/file]", "")
          .replaceAll(" ", "");
      }
      window.open(this.uri, "_blank");
      if (isSourceInstagram) return true;
      if (hasExtension) return true;

      actions.push({
        text: "Yes, open it",
        onClick: (e, toastObject) => {
          window.open(this.uri);
          toastObject.goAway(0);
        }
      });
      actions.push({
        text: "Cancel",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
          return false;
        }
      });
      return this.$toasted.show(
        "Are you sure you want to open this file, make sure the file is trusted?",
        {
          duration: 5000,
          action: actions
        }
      );
    },
    imageFallback() {
      if (
        this.comment.extras.type === "text" &&
        this.comment.payload.hasOwnProperty("replied_comment_type")
      ) {
        if (this.comment.payload.replied_comment_type === "file_attachment") {
          this.isImage = false;
        }
      }
      this.imageSrc = "https://omnichannel.qiscus.com/img/broken-image.jpg";
      this.imageLoaded();
    },
    getImageThumbnail(url, width, height) {
      if (!url || (url && url.includes(".webp"))) return url;
      if (typeof width == "undefined" && typeof height == "undefined")
        return url;
      const baseUrlSegment = url.split("//");
      const urlSegment = baseUrlSegment[1].split("/");
      if (urlSegment.length !== 6) return url;
      // take two last segment
      const imageRelativePath = `${urlSegment[4]}/${urlSegment[5]}`;
      const baseImagePath = url.substr(
        0,
        url.length - imageRelativePath.length
      );
      if (typeof width !== "undefined" && typeof height !== "undefined") {
        // return `${baseImagePath}c_thumb,g_center,h_100,w_100/${imageRelativePath}`;
        return baseImagePath + imageRelativePath;
      }
      return `${baseImagePath}w_320,h_320,c_limit/${imageRelativePath}`;
    },
    clickImageHandler() {
      if (this.comment.extras.hasOwnProperty("replied_msg")) {
        window.open(this.uri, "_blank");
        return;
      }
      if (this.onClickImage && !this.isCommentReply) {
        return this.onClickImage(this.comment);
      }
      return false;
    },
    isImageAttachment(message) {
      return message.match(/\.(jpg|jpeg|gif|png|webp)/i) != null;
    },
    loadImage() {
      const self = this;
      const comment = self.comment;
      let textMessage = null;

      if (!self.isReply) {
        textMessage = self.message;
      } else {
        textMessage = self.isCommentReply
          ? comment.payload.replied_comment_message
          : comment.payload.text;
      }

      self.isLoading = true;
      self.$nextTick(() => {
        const extras = comment.extras;
        self.isImage = self.isImageAttachment(textMessage);
        if (
          extras.type === "text" &&
          comment.payload.hasOwnProperty("replied_comment_type")
        ) {
          if (comment.payload.replied_comment_type === "file_attachment") {
            self.isImage = true;
          }
        }
        if (
          !self.isCommentReply &&
          extras.source === "ig" &&
          extras.type === "image"
        ) {
          self.isImage = true;
        }
        if (
          extras.type === "interactive_wa" &&
          ["reply_buttons", "cta_url", "flow"].includes(extras.sub_type)
        ) {
          self.uri =
            self.isImage && self.thumbnailMode
              ? self.getImageThumbnail(textMessage, 100, 100)
              : textMessage;
        } else {
          self.uri =
            self.isImage && self.thumbnailMode
              ? self.getImageThumbnail(
                comment.getAttachmentURI(textMessage),
                100,
                100
              )
              : comment.getAttachmentURI(textMessage);
        }
        if (self.uri) {
          self.filename = self.uri
            .split("/")
            .pop()
            .split("#")[0]
            .split("?")[0];
          self.ext = self.filename.split(".").pop();
        }
        self.error = "";
        if (self.isImage) {
          self.imageSrc =
            self.uri.substr(0, self.uri.length - self.ext.length) + self.ext;
        }
        if (!self.isImage) self.imageLoaded();
        if (extras.source === "ig") {
          switch (extras.type) {
            case "audio":
              self.isImage = false;
              self.filename = "Instagram Voice Note";
              break;
            case "video":
              self.isImage = false;
              self.filename = "Instagram Video";
              break;
            case "story_reply":
              self.isImage = false;
              self.filename = "Instagram Story";
              break;
            case "video_story_reply":
              self.isImage = false;
              self.filename = "Instagram Video Story";
              break;
            case "image_story_reply":
              self.isImage = false;
              self.filename = "Instagram Image Story";
              break;
            case "story_mention":
              self.isImage = false;
              self.filename = "Instagram Story";
              break;
            case "share":
              self.isImage = false;
              self.filename = "Instagram Post";
              break;
            case "video_ig_comment":
              self.isImage = false;
              self.filename = "Instagram Video Post";
              break;
            case "image_ig_comment":
              self.isImage = false;
              self.filename = "Instagram Image Post";
              break;
            case "carousel_album_ig_comment":
              self.isImage = false;
              self.filename = "Instagram Carousel Album Post";
              break;
            default:
              break;
          }
          if (this.isCommentReply && this.isFileAttachment) {
            self.filename = comment.payload.replied_comment_payload.file_name;
          }
        }
      });
    },
    imageLoaded() {
      this.isLoading = false;
    }
  }
};
</script>

<style lang="stylus">
@import '../assets/stylus/_variables.styl'
.file-container-reply
  display flex
  align-items center
  justify-content center
  padding 0px
.image-loader
  margin -4px
  overflow hidden
  border-radius 16px
.reply-wrapper .image-loader
  margin-top 4px
  padding-bottom 4px
.reply-wrapper .qcw-image-container
  margin 0
  width 100%
.image-loader--text
  white-space normal

.image-loader + .qcw-comment__content
  width 100%
  overflow hidden
  text-overflow ellipsis
  margin-top 12px
  word-break break-word
  a
    word-break break-all

.loading-image-container
  min-width 194px
  height 194px !important
  display flex
  justify-content center
  flex-direction column

.reply-wrapper--preview .qcw-image-container,
.qcw-comment__message .qcw-image-container
  display flex
  align-items center
  justify-content center
  overflow hidden
  max-height 220px
  cursor pointer

@media only screen and (min-width: 678px)
  .reply-wrapper--preview .qcw-image-container,
  .qcw-comment__message .qcw-image-container
    img
      // aspect-ratio 4/3
      width: 100%

.qcw-image-container
  img
    height 100%
    width 100%
    display block
    object-fit contain

.reply-wrapper--preview .qcw-file-container
  margin 4px 0 0 0
  a
    justify-content flex-start

.qcw-file-container
  //background-color $darkWhite
  padding 4px 8px
  border-radius 4px
  word-break break-word
  a
    //color $darkGrey
    text-decoration none
    display flex
    align-items top
    justify-content left
  i
    display flex
    align-items: center
    justify-content: center
    margin-right 8px
    svg
      margin 0
      fill $mediumGrey
      width 16px
      height 16px
  .file-meta
    font-size 13px
    overflow ellipsis
    display flex
    align-items center
    .file-name
      font-weight 400
      font-size 14px
      line-height 1.2
      background: transparent !important

    .file-description
      font-size 11px
      font-weight 200
      line-height 14px

.reload-image-btn {
  display: block;
  width: 100%;
  margin: 10px 0;
  padding: 7px 15px;
  text-align: center;
  cursor: pointer;
  background: #eee;
  color: #FFF;
  border: 2px solid #FFF;
  font-weight: bold;
  border-radius: 5px;
  color: #444;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageLoader.vue